export default __webpack_public_path__ + "static/media/section3_2.17552637.png";